let paths = {};

paths.swiper = 'swiper/dist/js/swiper.min';

requirejs.config({
    baseUrl: js_config.theme_base + '/node_modules',
    paths: paths
});

requirejs(['require'],
    function (require) {
        const swiperContainers = document.getElementsByClassName('swiper-container');
        if (swiperContainers.length > 0) {
            require(['swiper'], function (Swiper) {
                for (let i = 0; i < swiperContainers.length; i++) {
                    new Swiper(swiperContainers[i], {
                        // Optional parameters
                        loop: false,
                        pagination: {
                            el: '.swiper-pagination',
                            type: 'fraction',
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                    });
                }
            });
        }
    }
);


// constants
const workNavigation = document.getElementById('work-navigation');
const blogNavigation = document.getElementById('blog-navigation');
const workCategoryDescription = document.getElementById('work-category-description');
const workContainer = document.getElementsByClassName('work-container');
const blogContainer = document.getElementsByClassName('blog-container');
const siteNavigation = document.getElementById('site-navigation');
const mobileToggle = document.getElementById('mobile-menu-toggle');
const scrollUpBtn = document.getElementById('scroll-to-top');
const gridContainer = document.getElementById('grid-container');
const preloader = document.getElementById('preloader');
const showMore = document.getElementById('description-expand');
const expandArrow = document.getElementById('expand-arrow');
const descriptionDetails = document.getElementById('single-text-details');
const searchInput = document.getElementById('search-input');
const searchSubmitButton = document.getElementById('search-submit');
const searchForm = document.getElementById('search-form');

/*---------------------------------------------
* HOME SITE
*---------------------------------------------- */

showDescription = (event) => {
    event.target.classList.add('show-caption');
};
hideDescription = (event) => {
    event.target.classList.remove('show-caption');
};

createHoverEventListeners = (className) => {
    const containers = document.getElementsByClassName(className);
    if (containers.size === 0 || !containers[0]) return;
    for (const container of containers) {
        const contentDivs = container.getElementsByClassName('content');
        for (const content of contentDivs) {
            content.addEventListener('mouseenter', showDescription);
            content.addEventListener('mouseleave', hideDescription);
        }
    }
};

// listeners
createHoverEventListeners('event-container');
createHoverEventListeners('posts');


/*---------------------------------------------
* WORK SITE
*---------------------------------------------- */
filterWorkPosts = (event) => {
    const deselect = event.target.classList.contains('active');
    const classToShow = event.target.dataset.slug;
    if (workContainer.size === 0) {
        return
    }
    const postsGrouped = workContainer[0].getElementsByClassName('posts');

    // find all posts on work site
    const posts = [];
    for (const postsDiv of postsGrouped) {
        posts.push(...postsDiv.getElementsByClassName('post'))
    }

    // activate clicked navigation element
    if (workNavigation) {
        for (const a of workNavigation.getElementsByTagName('a')) {
            a.classList.remove('active')
        }
        if (!deselect) event.target.classList.add('active');
    }

    // set visibility of posts
    for (const post of posts) {
        if (!deselect) {
            if (post.classList.contains(classToShow)) {
                post.classList.remove('hide');
                post.classList.add('show');
            } else {
                post.classList.add('hide');
                post.classList.remove('show');
            }
        } else {
            post.classList.remove('hide');
            post.classList.add('show');
        }
    }

    if (!deselect) {
        if (workCategoryDescription) {
            workCategoryDescription.classList.remove('hidden');
            workCategoryDescription.innerText = event.target.dataset.description;
        }
    } else {
        workCategoryDescription.classList.add('hidden');
        workCategoryDescription.innerText = '';
    }

    removeEmptySections(workContainer[0]);
    fixWorkContainerPosition()
};


filterBlogPosts = (event) => {
    const deselect = event.target.classList.contains('active');
    const classToShow = event.target.dataset.slug;
    if (blogContainer.size === 0) {
        return
    }
    const posts = blogContainer[0].getElementsByClassName('post');

    // activate clicked navigation element
    if (blogNavigation) {
        for (const a of blogNavigation.getElementsByTagName('a')) {
            a.classList.remove('active')
        }
        if (!deselect) event.target.classList.add('active');
    }

    // set visibility of posts
    for (const post of posts) {
        if (!deselect) {
            if (post.classList.contains(classToShow)) {
                post.classList.remove('hide');
                post.classList.add('show');
            } else {
                post.classList.add('hide');
                post.classList.remove('show');
            }
        } else {
            post.classList.remove('hide');
            post.classList.add('show');
        }
    }
};

removeEmptySections = (container) => {
    const sections = container.getElementsByTagName('section');
    for (let i = 0; i < sections.length; i++) {
        const posts = sections[i].getElementsByClassName('post');
        let n = 0;
        for (let j = 0; j < posts.length; j++) {
            if (posts[j].classList.contains('hide')) n++;
        }
        if (posts.length === n) {
            sections[i].style.visibility = 'hidden';
        } else {
            sections[i].style.visibility = 'visible';
        }
    }
};


/*---------------------------------------------
* Menu
*---------------------------------------------- */

fixMenuPosition = (nav) => {
    nav.style.top = siteNavigation.offsetHeight + 'px';
};

fixWorkCategoryDescriptionDiv = () => {
    if (workCategoryDescription && workNavigation && siteNavigation) {
        workCategoryDescription.style.top = siteNavigation.offsetHeight + workNavigation.offsetHeight + 'px';
    }
};

fixWorkContainerPosition = () => {
    const workContainer = document.getElementsByClassName('work-container')[0];
    workContainer.style.marginTop = 30 + siteNavigation.offsetHeight + workNavigation.offsetHeight + workCategoryDescription.offsetHeight + 'px'
};

toggleMenu = (event) => {
    event.target.classList.toggle('active');
    document.getElementById('primary-menu').classList.toggle('active');
};

showScrollToTop = () => {
    if (document.body.scrollTop > 350 || document.documentElement.scrollTop > 350) {
        scrollUpBtn.classList.add('active');
    } else {
        scrollUpBtn.classList.remove('active');
    }
};

scrollToTop = () => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
};

if (workNavigation) {
    const filters = workNavigation.getElementsByTagName('a');
    for (const filter of filters) {
        filter.addEventListener('click', filterWorkPosts);
    }
    fixMenuPosition(workNavigation);
    fixWorkCategoryDescriptionDiv();
}

if (blogNavigation) {
    const filters = blogNavigation.getElementsByTagName('a');
    for (const filter of filters) {
        filter.addEventListener('click', filterBlogPosts);
    }
    fixMenuPosition(blogNavigation);
}

if (mobileToggle) {
    mobileToggle.addEventListener('click', toggleMenu);
}

if (scrollUpBtn) {
    scrollUpBtn.addEventListener('click', scrollToTop);
    window.addEventListener("scroll", showScrollToTop)
}


/*---------------------------------------------
* Menu
*---------------------------------------------- */

pos = (index) => {
    if ((index + 1) % 2 === 0) {
        return 1
    } else if ((index + 1) % 4 === 1) {
        return 0;
    } else {
        return 2;
    }
};

let randomGridLocked = false;
randomGrid = () => {
    if (randomGridLocked) return;
    let offsetY = [0, 0, 0];
    let y = 0;
    if (gridContainer && window.innerWidth >= 1001) {
        randomGridLocked = true;
        gridContainer.classList.remove('grid');
        const articles = gridContainer.getElementsByTagName('article');
        for (let i = 0; i < articles.length; i++) {
            y = offsetY[pos(i)] = Math.max(offsetY[pos(i)], y);
            articles[i].style.position = 'absolute';
            articles[i].style.top = y + 'px';
            articles[i].style.width = Math.floor(Math.random() * 6 + 25) + '%';

            offsetY[pos(i)] += Math.max(articles[i].offsetHeight + Math.random() * 30 + 30, 500);
            y += Math.random() * 50 + articles[i].offsetHeight / 3 + 200;

            if (pos(i) === 0)
                articles[i].style.left = 0;
            if (pos(i) === 1)
                articles[i].style.left = gridContainer.offsetWidth / 2 - articles[i].offsetWidth / 2 + 'px';
            if (pos(i) === 2)
                articles[i].style.right = 0;
        }
    }
    if (gridContainer) {
        gridContainer.style.opacity = '1';
    }
};

gridResize = () => {
    const articles = gridContainer.getElementsByTagName('article');
    if (window.innerWidth >= 1001) {
        for (let i = 0; i < articles.length; i++) {
            if (pos(i) === 0)
                articles[i].style.left = 0;
            if (pos(i) === 1)
                articles[i].style.left = gridContainer.clientWidth / 2 - articles[i].offsetWidth / 2 + 'px';
            if (pos(i) === 2)
                articles[i].style.right = 0;
        }
    } else {
        gridContainer.classList.add('grid');
        for (let i = 0; i < articles.length; i++) {
            articles[i].style.position = '';
            articles[i].style.top = '';
            articles[i].style.width = '';
            articles[i].style.opacity = 1;
        }
    }
    gridContainer.style.opacity = '1';
};

onResize = (event) => {
    if (gridContainer) {
        gridResize(event);
    }
    if (workNavigation) {
        fixMenuPosition(workNavigation);
        fixWorkCategoryDescriptionDiv();
    }
};

// preloader
hideElement = (element, ms) => {
    setTimeout(() => {
        element.style.opacity = 0;
        setTimeout(() => element.style.visibility = 'hidden', 1000);
    }, ms)
};

if (preloader) {
    hideElement(preloader, 3000);
}

// image post expand

showDescription = (event) => {
    expandArrow.classList.toggle('rotate-180');
    descriptionDetails.classList.toggle('show');
};

if (showMore) {
    showMore.addEventListener('click', showDescription);
}

// listeners
setTimeout(randomGrid, 1000);
window.addEventListener('resize', onResize);


/* --------------
Search
--------------- */

submitSearch = (ev) => {
    ev.preventDefault();
    window.location.href = searchInput.value;
};

if (searchForm) {
    searchForm.addEventListener('submit', submitSearch);
    searchSubmitButton.addEventListener('click', submitSearch);
}

/* --------------
Podcast Player
--------------- */
formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60)
    const seconds = Math.floor(timeInSeconds % 60)

    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

const podcastPlayers = document.getElementsByClassName('podcast-player');
for (const player of podcastPlayers) {

    player
        .querySelector('.play-icon')
        .addEventListener('click', () => {
            const audio = player.querySelector('audio');
            if (audio.paused) {
                audio
                    .play()
                    .then(() => {
                        player.querySelector('.play-icon').classList.add('playing')
                        player.querySelector('.play-icon').classList.remove('pausing')
                    })
            } else {
                audio.pause()
                player.querySelector('.play-icon').classList.add('pausing')
                player.querySelector('.play-icon').classList.remove('playing')
            }
        })

    player
        .querySelector('audio')
        .addEventListener('timeupdate', (ev) => {
            const buttonWidth = 12;
            const playerWidth = player.offsetWidth;
            const width = playerWidth - buttonWidth;

            const progress = ev.srcElement.currentTime / ev.srcElement.duration;

            const leftWidth = width * progress;
            const rightWidth = width - leftWidth;

            player.querySelector('.progress-bar .left').style.width = leftWidth + 'px';
            player.querySelector('.progress-bar .right').style.width = rightWidth + 'px';


            const currentTime = Math.floor(ev.srcElement.currentTime);
            const duration = Math.floor(ev.srcElement.duration);

            player
                .querySelector('.progress-bar .time .current-time')
                .innerHTML = formatTime(currentTime);

            player
                .querySelector('.progress-bar .time .time-left')
                .innerHTML = formatTime(duration - currentTime);
        })

}
